'use client';

import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from '@/contexts/AuthContext';
import i18n from '@/i18n/config';

export const Providers: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [queryClient] = React.useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        refetchOnWindowFocus: false,
                        retry: 1,
                    },
                },
            })
    );

    useEffect(() => {
        const stored = localStorage.getItem('language');
        if (stored && stored !== i18n.language) {
            i18n.changeLanguage(stored);
        }
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <HelmetProvider>
                <AuthProvider>{children}</AuthProvider>
            </HelmetProvider>
        </QueryClientProvider>
    );
};
